<template>
  <el-card>
    <div class="micro-page">
      <div class="title mb20 flex item-center">分享页面</div>
      <ul class="custom-list flex flex-wrap">
        <li class="temp custom" @click="toTemp(null)">
          <div class="custom-wrapper flex item-center flex-center">
            <div class="text-center">
              <span class="hmicon icon-weiyemian"></span>
              <div>自定义模板</div>
            </div>
          </div>
          <div class="temp-title">&nbsp;</div>
        </li>
        <li class="temp" v-for="(v, i) in list" :key="i">
          <div class="temp-wrapper">
            <img :src="v.previewImg" alt="默认首页" />
            <div class="default-wrapper" v-if="v.enabledState === 'yes'">
              默认
            </div>
            <div class="temp-btn-wrapper">
              <div class="flex item-center wrapper">
                <div class="flex flex-wrap flex-start">
                  <el-tooltip
                    class="item"
                    content="设为默认样式"
                    placement="top"
                  >
                    <el-button
                      @click="setDefault(v)"
                      style="color: #0081E5"
                      icon="hmicon icon-wangge"
                      circle
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    content="编辑"
                    placement="top"
                    style="color: #0081E5"
                  >
                    <el-button
                      @click="edit(v)"
                      icon="hmicon icon-bianji"
                      circle
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    content="删除"
                    placement="top"
                    style="color: #E50065"
                  >
                    <el-button
                      @click="deleteItem(v.shareId)"
                      icon="hmicon icon-shanchu"
                      circle
                    ></el-button>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div class="temp-title">模板{{ i + 1 }}</div>
        </li>
      </ul>
    </div>
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import JDatePicker from "vue-jlunar-datepicker";
export default {
  components: { JDatePicker },
  data() {
    return {
      type: "DATERANGE",
      showBackYears: 2,
      width1: "300",
      clearable: true,
      list: [],
      micropageId: "",
      currentMicropageId: "",
      homeImg:
        "https://imgcdn.hemiao100.com/hemiaoBase/cdead4d7-3f67-43c5-85c1-5ee03c30f965.png",
      userCenterImg:
        "https://imgcdn.hemiao100.com/hemiaoBase/TIM%E6%88%AA%E5%9B%BE20190903104340.png",
      ruleForm: {
        hrefAddress: "",
        pageType: "index",
        enabledDate: [],
        enabledState: "close"
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      rules: {
        enabledDate: {
          required: false,
          message: "请选择时间",
          trigger: "change"
        }
      },
      dialogVisible: false
    };
  },
  computed: mapGetters(["indexTemp"]),
  watch: {
    indexTemp(val) {
      if (val.layoutDefaultBoList) {
        val.layoutDefaultBoList.map(v => {
          if (v.pageType === "home") {
            this.homeImg = v.previewImg;
          } else if (v.pageType === "center") {
            this.userCenterImg = v.previewImg;
          }
        });
      }
    }
  },
  mounted() {
    this.queryList();
  },
  methods: {
    async queryList() {
      this.list = [];
      const { result } = await this.$store.dispatch("queryGoodShareTempList", {
        sharePageType: "live"
      });
      this.list = result;
    },
    switchPageType() {
      this.ruleForm.hrefAddress =
        this.ruleForm.pageType === "index" ? "" : "customPage1";
    },
    switchEnabledState(state) {
      this.rules.enabledDate.required = state === "open";
    },
    async setDefault(row) {
      const params = JSON.parse(JSON.stringify(row))
      params.enabledState = 'yes'
      params.shareId = row.shareId
      await this.$store.dispatch("editGoodShareTemp", params);
      this.queryList();
    },
    edit(row) {
      this.$store.commit("SET_GOODS_TEMP_ROW", row);
      this.$router.push({
        name: "LiveShareTemp",
        query: {
          mode: "edit",
          shareId: row.shareId
        }
      });
    },
    async deleteItem(shareId) {
      const result = await this.$confirm(" 删除本条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        await this.$store.dispatch("editGoodShareTemp", {
          shareId,
          delFlag: "1"
        });
        this.queryList();
        this.$message({
          type: "success",
          message: "操作成功！"
        });
      }
    },
    toTemp(layoutId) {
      let query = {
        pageModel: "customize"
      };
      if (layoutId) {
        Object.assign(query, {
          layoutId,
          mode: "edit"
        });
      }
      this.$router.push({
        name: "LiveShareTemp",
        query
      });
    }
  }
};
</script>
<style>
.full-jcalendar__body .day-cell .day-number .solar {
  height: 18px;
}
.full-jcalendar .input-icon {
  top: 0 !important;
}
.full-jcalendar__body {
  height: 346px !important;
}
</style>
<style lang="scss" scoped>
.title {
  position: relative;
  font-size: 14px;
  font-weight: bold;
  &::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 14px;
    background: rgba(229, 0, 101, 1);
    border-radius: 2px 0px 2px 0px;
    margin-right: 5px;
  }
}

.temp {
  position: relative;
  margin-right: 20px;
  cursor: pointer;
  margin-bottom: 20px;
  overflow: hidden;
  &:hover {
    .temp-btn-wrapper {
      display: block;
    }
  }
  .default-wrapper {
    background: #e50065;
    color: #fff;
    position: absolute;
    top: -50px;
    left: -50px;
    font-size: 14px;
    width: 100px;
    height: 100px;
    line-height: 160px;
    text-align: center;
    transform: rotate(315deg);
  }
  &-wrapper {
    height: 394px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &-title {
    background: #fff;
    font-size: 14px;
    font-weight: 500;
    width: 226px;
    text-align: center;
    padding: 11px 0;
  }
  &-btn-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 38px;
    height: 394px;
    padding-left: 35px;
    display: none;
    background: rgba(0, 0, 0, 0.8);
    .wrapper {
      height: 100%;
    }
    .el-button {
      margin: 0;
      margin-bottom: 20px;
      margin-right: 15px;
    }
  }
}
.temp {
  width: 226px;
  height: 423px;
  box-shadow: 0 1px 20px rgba(0, 0, 0, 0.1);
}

.temp.custom {
  .custom-wrapper {
    height: 394px;
    background: #ffd4e7;
    text-align: center;
    color: #e50065;
    font-size: 14px;
    .hmicon {
      font-size: 42px;
    }
  }
}
</style>
